module.exports = __webpack_public_path__ + "static/media/PreOrientation_Kayak20170822_JO002.757d3934.jpg";